import type { PropType } from 'vue';
import { FormItem } from './types/form';
import type { PaginationProps } from './types/pagination';
import type {
  BasicColumn,
  FetchSetting,
  SorterResult,
  TabConfig,
  TabItems,
  TableCustomRecord,
  TableRowSelection,
} from './types/table';
const DEFAULT_FILTER_FN = (data: Partial<Recordable<string[]>>) => {
  return data;
};
const DEFAULT_SORT_FN = (sortInfo: SorterResult) => {
  const { field, order } = sortInfo;
  return {
    order_by: field,
    order: order === 'ascend' ? 'asc' : 'desc',
  };
};
const FETCH_SETTING = {
  pageField: 'page',
  sizeField: 'rowsPerPage',
  listField: 'items',
  totalField: 'total',
  orderByField: 'order_by',
  orderField: 'order',
};
export const basicProps = {
  options: {
    type: Object as PropType<Recordable>,
    default: () => {
      return null;
    },
  },
  need_view_filter: {
    type: Boolean,
    default: false,
  },
  table_key: {
    type: String,
    default: '',
  },
  useFilterFromColumns: {
    type: Boolean,
    default: true,
  },
  useWatchInitDefault: {
    type: Boolean,
    default: false,
  },
  formItems: {
    type: Array as PropType<FormItem[]>,
    default: () => [],
  },
  initItem: {
    type: Function,
    default: null,
  },
  activeKey: {
    type: String || Number,
    default: '',
  },
  tabItems: {
    type: Array as PropType<TabItems[]>,
  },
  tabConfig: {
    type: Object as PropType<TabConfig>,
    default: () => {
      return {};
    },
  },
  inset: {
    type: Boolean,
  },
  sortFn: {
    type: Function as PropType<(sortInfo: SorterResult) => any>,
    default: DEFAULT_SORT_FN,
  },
  filterFn: {
    type: Function as PropType<(data: Partial<Recordable<string[]>>) => any>,
    default: DEFAULT_FILTER_FN,
  },
  autoCreateKey: {
    type: Boolean,
    default: true,
  },
  striped: {
    type: Boolean,
    default: true,
  },
  showSummary: {
    type: Boolean,
  },
  summaryFunc: {
    type: [Function, Array] as PropType<(...arg: any[]) => any[]>,
    default: null,
  },
  summaryData: {
    type: Array as PropType<Recordable[]>,
    default: null,
  },
  indentSize: {
    type: Number,
    default: 24,
  },
  tableCol: {
    type: Number,
    default: 24,
  },
  canColDrag: {
    type: Boolean,
    default: true,
  },
  api: {
    type: Function as PropType<(...arg: any[]) => Promise<any>>,
    default: null,
  },
  isWeApi: {
    type: Boolean,
    default: true,
  },
  fetchSetting: {
    type: Object as PropType<FetchSetting>,
    default: () => {
      return FETCH_SETTING;
    },
  },
  // 立即请求接口
  immediate: {
    type: Boolean,
    default: true,
  },
  emptyDataIsShowTable: {
    type: Boolean,
    default: true,
  },
  // 额外的请求参数
  searchInfo: {
    type: Object as PropType<Recordable>,
    default: null,
  },
  // 使用搜索表单
  useSearchForm: {
    type: Boolean,
    default: true,
  },
  tableLayout: {
    type: String,
    default: 'fixed',
  },
  columns: {
    type: [Array] as PropType<BasicColumn[]>,
    default: () => [],
  },
  showIndexColumn: {
    type: Boolean,
    default: false,
  },
  indexColumnProps: {
    type: Object as PropType<BasicColumn>,
    default: null,
  },
  actionColumn: {
    type: Object as PropType<BasicColumn>,
    default: null,
  },
  ellipsis: {
    type: Boolean,
    default: true,
  },
  clearSelectOnPageChange: {
    type: Boolean,
  },
  title: {
    type: [String, Function] as PropType<string | ((data: Recordable) => string)>,
    default: null,
  },
  dataSource: {
    type: Array as PropType<Recordable[]>,
    default: null,
  },
  rowKey: {
    type: [String, Function] as PropType<string | ((record: Recordable) => string)>,
    default: 'id',
  },
  bordered: {
    type: Boolean,
  },
  pagination: {
    type: [Object, Boolean] as PropType<PaginationProps | boolean>,
    default: null,
  },
  loading: {
    type: Boolean,
  },
  rowClassName: {
    type: Function as PropType<(record: TableCustomRecord<any>, index: number) => string>,
  },
  rowSelection: {
    type: Object as PropType<TableRowSelection | null>,
    default: null,
  },
  selections: {
    type: Array,
    default: () => [],
  },
  showTableHeader: {
    type: Boolean,
    default: true,
  },
  showTableInfo: {
    type: Boolean,
    default: false,
  },
  moreFunc: {
    type: Array,
    default: () => [],
  },
  scroll: {
    type: Object as PropType<{ x: number | true; y: number }>,
    default: () => {
      return {};
    },
  },
  sortDirections: {
    type: Array,
    default: () => ['descend', 'ascend'],
  },
  display_type: {
    type: String,
    default: 'table',
  },
  getCollect: {
    type: Boolean,
    default: null,
  },
};
